import { useQuery } from '@tanstack/react-query';

import { StandardsQueryKeys, useStandardsApi } from '@/api';

import { mapStandards } from '../api-mappers';

export const useGetStandards = () => {
  const { standardsApi } = useStandardsApi();

  const { data, isLoading, isError, refetch, isRefetching } = useQuery({
    queryKey: [StandardsQueryKeys.standardsList],
    queryFn: async () => {
      const response = await standardsApi.getStandardsApiStandardsGet();
      return mapStandards(response.data);
    },
  });

  return {
    standards: data,
    isStandardsLoading: isLoading || isRefetching,
    isStandardsError: isError,
    refetchStandards: refetch,
  };
};